import React, { useContext } from 'react'

import * as style from './style.module.sass'

import MicrocmsImage from '@atoms/MicrocmsImage'
import ExpandingImageLink from '@molecules/ExpandingImageLink'
import SaveButton from '@molecules/SaveButton'
import VoicePlayButton from '@molecules/VoicePlayButton'
import MaskedIcon from '@icons/Masked'
import { useTranslation } from '@models/Translation'
import { StoreContext } from '@models/Store'
import { Article } from '@models/Article'

export type ArtisanArticleListProps = {
  articles: Article[]
  gtmClickType: string
}

const ArtisanArticleList: React.FC<ArtisanArticleListProps> = ({
  articles,
  gtmClickType,
}) => {
  const { entity } = useContext(StoreContext)
  const { locale } = useTranslation()

  return (
    <div className={style.list}>
      {articles.map(article => {
        const isMasked =
          entity?.user?.isSignIn !== true && article.isMembersOnly
        return (
          <div
            className={style.articleContainer}
            key={article.blogId}
            data-gtm-click={`article-list-${gtmClickType}`}
            data-gtm-value={article.blogId}
          >
            <ExpandingImageLink to={article.path} isSlow>
              <div className={style.imageContainer}>
                <MicrocmsImage
                  image={article.thumbnail}
                  alt={article.title}
                  type="thumbnail"
                  disableAspectRatio
                />

                <div
                  className={style.saveContainer}
                  data-gtm-click={`save-list-${gtmClickType}`}
                  data-gtm-label={entity.bookmark[article.blogId] !== true}
                  data-gtm-value={article.blogId}
                >
                  <SaveButton
                    blogId={article.blogId}
                    active={entity.bookmark[article.blogId] === true}
                    type="dark"
                  />
                </div>
              </div>
              <div className={style.info}>
                {article.publishDate}
                <div className={style.titleContainer}>
                  <div>
                    <span className={style.title} data-en={locale === 'en'}>
                      {article.title}
                      {isMasked && (
                        <span className={style.masked}>
                          <MaskedIcon />
                        </span>
                      )}
                    </span>
                  </div>

                  {article.enableVoice && !isMasked && (
                    <div className={style.voiceContainer}>
                      <VoicePlayButton article={article} />
                    </div>
                  )}
                </div>
              </div>
            </ExpandingImageLink>
          </div>
        )
      })}
    </div>
  )
}

export default ArtisanArticleList
